import React from 'react';

import { Text, Title } from '@asteria/component-core/typography';

import { TranslationService } from '@asteria/language';
import useConfig from '@asteria/utils-hooks/useConfig';

const SignupFeatures = () => {
	const featureImages = useConfig('pages.auth.content.features', {
		deep: true,
	});

	const feature_images_image1 =
		featureImages && featureImages[0] ? featureImages[0].props.src : '';
	const feature_images_image2 =
		featureImages && featureImages[1] ? featureImages[1].props.src : '';
	const feature_images_image3 =
		featureImages && featureImages[2] ? featureImages[2].props.src : '';
	const feature_images_image4 =
		featureImages && featureImages[3] ? featureImages[3].props.src : '';

	return (
		<div className="asteria-component__section asteria-component__section--variant-features">
			<Title size="sm">
				{TranslationService.getV2([
					'auth.partner.swedbank.hero.features.title',
				])}
			</Title>
			<div className="asteria-component__features">
				<div className="asteria-component__features-feature">
					<img
						className="asteria-component__image"
						src={feature_images_image1}
						alt="Payments"
					/>
					<Title size="xs">
						{TranslationService.getV2([
							'auth.partner.swedbank.hero.feature-1.title',
						])}
					</Title>
					<Text size="sm">
						{TranslationService.getV2([
							'auth.partner.swedbank.hero.feature-1.text',
						])}
					</Text>
				</div>
				<div className="asteria-component__features-feature">
					<img
						className="asteria-component__image"
						src={feature_images_image2}
						alt="Taxes"
					/>
					<Title size="xs">
						{TranslationService.getV2([
							'auth.partner.swedbank.hero.feature-2.title',
						])}
					</Title>
					<Text size="sm">
						{TranslationService.getV2([
							'auth.partner.swedbank.hero.feature-2.text',
						])}
					</Text>
				</div>
				<div className="asteria-component__features-feature">
					<img
						className="asteria-component__image"
						src={feature_images_image3}
						alt="Forecast"
					/>
					<Title size="xs">
						{TranslationService.getV2([
							'auth.partner.swedbank.hero.feature-3.title',
						])}
					</Title>
					<Text size="sm">
						{TranslationService.getV2([
							'auth.partner.swedbank.hero.feature-3.text',
						])}
					</Text>
				</div>
				<div className="asteria-component__features-feature">
					<img
						className="asteria-component__image"
						src={feature_images_image4}
						alt="Salary"
					/>
					<Title size="xs">
						{TranslationService.getV2([
							'auth.partner.swedbank.hero.feature-4.title',
						])}
					</Title>
					<Text size="sm">
						{TranslationService.getV2([
							'auth.partner.swedbank.hero.feature-4.text',
						])}
					</Text>
				</div>
			</div>
		</div>
	);
};

export default SignupFeatures;
